// extracted by mini-css-extract-plugin
module.exports = {"brand-remove-btn":"brand-remove-btn_2yva5","minus-btn-icon":"minus-btn-icon_3cU7m","brand-spinner":"brand-spinner_1pEZQ","dynamic-form":"dynamic-form_3PZxw"};